export const SPACES_BUCKET = 'lilowrite-spaces'

export function toSafeStorageSpaceId(spaceId: string): string {
  return spaceId.replace(/[^a-zA-Z0-9-_]/g, '-')
}

export function toStoragePath(ownerId: string, spaceId: string): string {
  return `spaces/${ownerId}/${toSafeStorageSpaceId(spaceId)}.json`
}

export function toOwnerStoragePrefix(ownerId: string): string {
  return `spaces/${ownerId}`
}

export function toSnapshotStoragePath(ownerId: string, spaceId: string, uploadStamp: string): string {
  return `spaces/${ownerId}/${toSafeStorageSpaceId(spaceId)}--${toSafeStorageSpaceId(uploadStamp)}.json`
}

export function resolveSyncStoragePath(ownerId: string, spaceId: string, path?: string | null): string {
  if (path == null) return toStoragePath(ownerId, spaceId)
  const prefix = `${toOwnerStoragePrefix(ownerId)}/`
  if (!path.startsWith(prefix) || !/^[a-zA-Z0-9_-]+[.]json$/.test(path.slice(prefix.length))) {
    throw new Error('invalid_cloud_path')
  }
  return path
}
